"use strict";

exports.__esModule = true;
exports.tooltipReducer = exports.tooltipPropsInitState = exports.TOOLTIP_ACTION_SCROLL = exports.TOOLTIP_ACTION_MOUSE_MOVE = exports.TOOLTIP_ACTION_MOUSE_LEAVE = void 0;
var _clone2 = _interopRequireDefault(require("ramda/src/clone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TOOLTIP_ACTION_SCROLL = exports.TOOLTIP_ACTION_SCROLL = "TOOLTIP_ACTION_SCROLL";
var TOOLTIP_ACTION_MOUSE_MOVE = exports.TOOLTIP_ACTION_MOUSE_MOVE = "TOOLTIP_ACTION_MOUSE_MOVE";
var TOOLTIP_ACTION_MOUSE_LEAVE = exports.TOOLTIP_ACTION_MOUSE_LEAVE = "TOOLTIP_ACTION_MOUSE_LEAVE";
var tooltipPropsInitState = exports.tooltipPropsInitState = {
  isOpen: false,
  props: {
    scrollLeft: 0,
    clientX: 0,
    clientY: 0,
    boundingClientRect: {
      left: 0,
      top: 0
    }
  }
};
var tooltipReducer = exports.tooltipReducer = function tooltipReducer(state, action) {
  var newState = (0, _clone2["default"])(state);
  if (action.type === TOOLTIP_ACTION_MOUSE_MOVE) {
    var _action$payload = action.payload,
      boundingClientRect = _action$payload.boundingClientRect,
      clientX = _action$payload.clientX,
      clientY = _action$payload.clientY;
    newState.isOpen = true;
    newState.props = Object.assign({}, newState.props, {
      boundingClientRect: boundingClientRect,
      clientX: clientX,
      clientY: clientY
    });
    return newState;
  } else if (action.type === TOOLTIP_ACTION_SCROLL) {
    var scrollLeft = action.payload.scrollLeft;
    newState.isOpen = true;
    newState.props = Object.assign({}, newState.props, {
      scrollLeft: scrollLeft
    });
    return newState;
  } else if (action.type === TOOLTIP_ACTION_MOUSE_LEAVE) {
    newState.isOpen = false;
    return newState;
  }
  return newState;
};